module.exports = __webpack_public_path__ + "28124f75a9e06aafa910f42a5ca22a3d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/keyart_blocker_frame.png
// module id = 444
// module chunks = 0